
// 관리자 설정
// 관리자
//
// @since 2018-06-01
// @author 강정규 ( devp012 )

export const state = () => ({
  url: '/api/sm/manager/admin',
  adminDataList: [],
  selectedItem: {
    id: '',
    text: '',
    option: '',
    checked: true,
    select: ''
  }
})

export const mutations = {
  getAdminData: (state, item) => {
    state.adminDataList = item
  },
  addAdmin: (state, item) => {
    state.adminDataList.push(item)
  },
  edtAdmin: (state, item) => {
    state.adminDataList.splice(state.selectedItem.itemIndex, 1, item)
  },
  delAdmin: (state, itemIndexList) => {
    itemIndexList = itemIndexList.sort().reverse()
    for (const itemIndex of itemIndexList) {
      state.adminDataList.splice(itemIndex, 1)
    }
  },
  setAdminDialog: () => {
  },
  clearAdminDialog: () => {
  }
}

export const actions = {
  async getAdminData ({commit, state}) {
    const res = {code: 'ok'}
    const {code, result} = await this.$axios.$get(state.url)
    if (code === 'ok') {
      commit('getAdminData', result)
    }
    return res
  },
  async addAdmin ({commit, state}, continued) {
    const res = {code: 'ok'}
    const {code, result} = await this.$axios.$post(state.url, state.selectedItem)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('addAdmin', result)
      if (!continued) {
        commit('clearAdminDialog')
      }
    }
    return res
  },
  async edtAdmin ({commit, state}) {
    const res = {code: 'ok'}
    const {code, result} = await this.$axios.$put(`${state.url}/${state.selectedItem.id}`, state.selectedItem)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('edtAdmin', result)
    }
    return res
  },
  async delAdmin ({commit, state}, param) {
    const res = {code: 'ok'}
    const {code, result} = await this.$axios.$delete(state.url, param.idList)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('delAdmin', result)
    }
    return res
  },
  async commandApply ({state}) {
    const {code} = await this.$axios.$put(`${state.url}/apply`, null, {applyMsg: true})
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    }
    return false
  },
  async commandCancel ({state}) {
    const {code} = await this.$axios.$put(`${state.url}/cancel`, null, {cancelMsg: true})
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    }
    return false
  }
}

export const getters = {}

export const strict = false
